import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type StaffFunctionsFetchedPayload = LabeledValuePayload[];

export type StaffFunctionsFetchedAction = {
	type: 'STAFF_FUNCTIONS_FETCHED';
	payload: StaffFunctionsFetchedPayload;
};

export default (payload: StaffFunctionsFetchedPayload): StaffFunctionsFetchedAction => ({
	type: 'STAFF_FUNCTIONS_FETCHED',
	payload,
});
